import React, { SyntheticEvent } from 'react';

import BankSelect from './BankSelect';
import { normalizeBankCode } from '../resources/bankCodeList';

type FormikField = {
  name?: string;
  value?: string;
  onBlur?: () => void;
};

type BankCodeDropdownProps = {
  field?: FormikField;
  value?: string;
  onChange?: (
    event: SyntheticEvent | null,
    data: { value: string; field?: FormikField; name?: string }
  ) => void;
  onBlur?: () => void;
  fluid?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
};

const BankCodeDropdown = ({
  field,
  value,
  onChange,
  onBlur,
  fluid,
  disabled,
  className,
  placeholder
}: BankCodeDropdownProps) => {
  const resolvedValue = field?.value ?? value ?? '';
  const hasError = Boolean(className?.includes('error'));

  const emitChange = (nextValue: string) => {
    const normalizedValue = normalizeBankCode(nextValue);
    const fieldData = field?.name ? { ...field, value: normalizedValue } : field;

    onChange?.(null, {
      value: normalizedValue,
      field: fieldData,
      name: field?.name
    });
  };

  return (
    <BankSelect
      value={resolvedValue}
      onChange={emitChange}
      onBlur={() => {
        field?.onBlur?.();
        onBlur?.();
      }}
      fluid={fluid}
      disabled={disabled}
      error={hasError}
      placeholder={placeholder || 'Digite o código ou nome do banco'}
      openUpward
    />
  );
};

export default BankCodeDropdown;
